const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://campuslens.xyz';

function authHeader() {
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  if (user?.access_token) {
    return { Authorization: `Bearer ${user.access_token}` };
  }
  return {};
}

// ── Images ───────────────────────────────────────────────────────────────────

export async function listImages() {
  const res = await fetch(`${API_BASE}/api/admin/images/`, { headers: authHeader() });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function uploadImage(file) {
  const form = new FormData();
  form.append('file', file);
  const res = await fetch(`${API_BASE}/api/admin/images/upload`, {
    method: 'POST',
    headers: authHeader(),
    body: form,
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export function imageUrl(filename) {
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const token = user?.access_token;
  // Append token as query param so <img src> works directly
  return `${API_BASE}/api/admin/images/${encodeURIComponent(filename)}?token=${token}`;
}

export async function deleteImage(filename) {
  const res = await fetch(`${API_BASE}/api/admin/images/${encodeURIComponent(filename)}`, {
    method: 'DELETE',
    headers: authHeader(),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

// ── Facilities ───────────────────────────────────────────────────────────────

export async function getFacilities() {
  const res = await fetch(`${API_BASE}/api/admin/facilities/`, { headers: authHeader() });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function createFacility(displayName, maxCapacity = 200) {
  const res = await fetch(`${API_BASE}/api/admin/facilities/`, {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ display_name: displayName, max_capacity: maxCapacity }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

// ── Cameras ──────────────────────────────────────────────────────────────────

export async function getCameras() {
  const res = await fetch(`${API_BASE}/api/admin/cameras/`, { headers: authHeader() });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function createCamera(location, facilityId, model = 'USB Camera') {
  const res = await fetch(`${API_BASE}/api/admin/cameras/`, {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ location, model, facility_id: facilityId }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function deleteCamera(cameraId) {
  const res = await fetch(`${API_BASE}/api/admin/cameras/${cameraId}`, {
    method: 'DELETE',
    headers: authHeader(),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

// ── Zones ─────────────────────────────────────────────────────────────────────

export async function getCameraZones(cameraId) {
  const res = await fetch(`${API_BASE}/api/admin/cameras/${cameraId}/zones/`, { headers: authHeader() });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function createZone(cameraId, name, facilityId, polygon, isExclusion = false) {
  const res = await fetch(`${API_BASE}/api/admin/cameras/${cameraId}/zones/`, {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, facility_id: facilityId, camera_id: cameraId, polygon, is_exclusion: isExclusion }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function deleteZone(zoneId) {
  const res = await fetch(`${API_BASE}/api/admin/zones/${zoneId}`, {
    method: 'DELETE',
    headers: authHeader(),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

// ── Public Facilities (dashboard) ─────────────────────────────────────────────

export async function getPublicFacilities() {
  const res = await fetch(`${API_BASE}/api/facilities`, { headers: authHeader() });
  if (!res.ok) throw new Error(await res.text());
  return res.json(); // { facilities: [{id, display_name, max_capacity}] }
}

// ── Occupancy ─────────────────────────────────────────────────────────────────

export async function getZonesOccupancy() {
  const res = await fetch(`${API_BASE}/api/zones/occupancy/`, { headers: authHeader() });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

// ── Capture Frame from Camera Working Dir ─────────────────────────────────────

export async function captureFrame(cameraId) {
  const res = await fetch(`${API_BASE}/api/admin/capture-frame/?camera_id=${cameraId}`, {
    method: 'POST',
    headers: authHeader(),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

// ── Run Detection ─────────────────────────────────────────────────────────────

export async function runDetection(cameraId, imageFilename) {
  const res = await fetch(`${API_BASE}/api/admin/run-detection/`, {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ camera_id: cameraId, image_filename: imageFilename }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}
